/**
 * Indian city-to-state mapping for auto-filling the State field when a City is typed.
 * Covers major cities & towns across all states.
 * Returns the state name or null if not found.
 */

const CITY_STATE_MAP = {
  // Andhra Pradesh
  'visakhapatnam': 'Andhra Pradesh', 'vijayawada': 'Andhra Pradesh', 'guntur': 'Andhra Pradesh',
  'nellore': 'Andhra Pradesh', 'kurnool': 'Andhra Pradesh', 'rajahmundry': 'Andhra Pradesh',
  'tirupati': 'Andhra Pradesh', 'kakinada': 'Andhra Pradesh', 'kadapa': 'Andhra Pradesh',
  'anantapur': 'Andhra Pradesh', 'eluru': 'Andhra Pradesh', 'ongole': 'Andhra Pradesh',
  'vizianagaram': 'Andhra Pradesh', 'machilipatnam': 'Andhra Pradesh', 'adoni': 'Andhra Pradesh',
  'tenali': 'Andhra Pradesh', 'proddatur': 'Andhra Pradesh', 'chittoor': 'Andhra Pradesh',
  'hindupur': 'Andhra Pradesh', 'bhimavaram': 'Andhra Pradesh', 'srikakulam': 'Andhra Pradesh',
  'amaravati': 'Andhra Pradesh',

  // Arunachal Pradesh
  'itanagar': 'Arunachal Pradesh', 'naharlagun': 'Arunachal Pradesh', 'pasighat': 'Arunachal Pradesh',

  // Assam
  'guwahati': 'Assam', 'silchar': 'Assam', 'dibrugarh': 'Assam', 'jorhat': 'Assam',
  'nagaon': 'Assam', 'tinsukia': 'Assam', 'tezpur': 'Assam', 'bongaigaon': 'Assam',

  // Bihar
  'patna': 'Bihar', 'gaya': 'Bihar', 'bhagalpur': 'Bihar', 'muzaffarpur': 'Bihar',
  'purnia': 'Bihar', 'darbhanga': 'Bihar', 'arrah': 'Bihar', 'begusarai': 'Bihar',
  'katihar': 'Bihar', 'munger': 'Bihar', 'chhapra': 'Bihar', 'sasaram': 'Bihar',
  'hajipur': 'Bihar', 'dehri': 'Bihar', 'siwan': 'Bihar', 'motihari': 'Bihar',
  'nawada': 'Bihar', 'saharsa': 'Bihar', 'bettiah': 'Bihar',

  // Chhattisgarh
  'raipur': 'Chhattisgarh', 'bhilai': 'Chhattisgarh', 'bilaspur': 'Chhattisgarh',
  'korba': 'Chhattisgarh', 'durg': 'Chhattisgarh', 'rajnandgaon': 'Chhattisgarh',
  'jagdalpur': 'Chhattisgarh', 'raigarh': 'Chhattisgarh', 'ambikapur': 'Chhattisgarh',

  // Delhi
  'delhi': 'Delhi', 'new delhi': 'Delhi',

  // Goa
  'panaji': 'Goa', 'margao': 'Goa', 'vasco da gama': 'Goa', 'mapusa': 'Goa', 'ponda': 'Goa',

  // Gujarat
  'ahmedabad': 'Gujarat', 'surat': 'Gujarat', 'vadodara': 'Gujarat', 'rajkot': 'Gujarat',
  'bhavnagar': 'Gujarat', 'jamnagar': 'Gujarat', 'junagadh': 'Gujarat', 'gandhinagar': 'Gujarat',
  'gandhidham': 'Gujarat', 'anand': 'Gujarat', 'navsari': 'Gujarat', 'morbi': 'Gujarat',
  'nadiad': 'Gujarat', 'surendranagar': 'Gujarat', 'bharuch': 'Gujarat', 'mehsana': 'Gujarat',
  'bhuj': 'Gujarat', 'porbandar': 'Gujarat', 'palanpur': 'Gujarat', 'valsad': 'Gujarat',
  'vapi': 'Gujarat', 'gondal': 'Gujarat', 'veraval': 'Gujarat', 'godhra': 'Gujarat',
  'patan': 'Gujarat', 'kalol': 'Gujarat', 'dahod': 'Gujarat', 'botad': 'Gujarat',
  'amreli': 'Gujarat',

  // Haryana
  'faridabad': 'Haryana', 'gurgaon': 'Haryana', 'gurugram': 'Haryana', 'panipat': 'Haryana',
  'ambala': 'Haryana', 'yamunanagar': 'Haryana', 'rohtak': 'Haryana', 'hisar': 'Haryana',
  'karnal': 'Haryana', 'sonipat': 'Haryana', 'panchkula': 'Haryana', 'bhiwani': 'Haryana',
  'sirsa': 'Haryana', 'bahadurgarh': 'Haryana', 'jind': 'Haryana', 'thanesar': 'Haryana',
  'kaithal': 'Haryana', 'rewari': 'Haryana', 'palwal': 'Haryana',

  // Himachal Pradesh
  'shimla': 'Himachal Pradesh', 'mandi': 'Himachal Pradesh', 'solan': 'Himachal Pradesh',
  'dharamshala': 'Himachal Pradesh', 'kullu': 'Himachal Pradesh', 'manali': 'Himachal Pradesh',
  'baddi': 'Himachal Pradesh', 'nahan': 'Himachal Pradesh', 'palampur': 'Himachal Pradesh',
  'hamirpur': 'Himachal Pradesh', 'una': 'Himachal Pradesh', 'bilaspur hp': 'Himachal Pradesh',

  // Jharkhand
  'ranchi': 'Jharkhand', 'jamshedpur': 'Jharkhand', 'dhanbad': 'Jharkhand',
  'bokaro': 'Jharkhand', 'deoghar': 'Jharkhand', 'hazaribagh': 'Jharkhand',
  'giridih': 'Jharkhand', 'ramgarh': 'Jharkhand', 'dumka': 'Jharkhand',

  // Karnataka
  'bengaluru': 'Karnataka', 'bangalore': 'Karnataka', 'mysuru': 'Karnataka', 'mysore': 'Karnataka',
  'hubli': 'Karnataka', 'mangaluru': 'Karnataka', 'mangalore': 'Karnataka', 'belgaum': 'Karnataka',
  'belagavi': 'Karnataka', 'davanagere': 'Karnataka', 'bellary': 'Karnataka',
  'gulbarga': 'Karnataka', 'kalaburagi': 'Karnataka', 'shimoga': 'Karnataka',
  'tumkur': 'Karnataka', 'raichur': 'Karnataka', 'bidar': 'Karnataka',
  'hospet': 'Karnataka', 'gadag': 'Karnataka', 'udupi': 'Karnataka', 'hassan': 'Karnataka',
  'dharwad': 'Karnataka', 'chitradurga': 'Karnataka',

  // Kerala
  'thiruvananthapuram': 'Kerala', 'kochi': 'Kerala', 'kozhikode': 'Kerala', 'calicut': 'Kerala',
  'thrissur': 'Kerala', 'kollam': 'Kerala', 'palakkad': 'Kerala', 'alappuzha': 'Kerala',
  'kannur': 'Kerala', 'kottayam': 'Kerala', 'malappuram': 'Kerala', 'ernakulam': 'Kerala',
  'thalassery': 'Kerala', 'kasaragod': 'Kerala',

  // Madhya Pradesh
  'indore': 'Madhya Pradesh', 'bhopal': 'Madhya Pradesh', 'jabalpur': 'Madhya Pradesh',
  'gwalior': 'Madhya Pradesh', 'ujjain': 'Madhya Pradesh', 'sagar': 'Madhya Pradesh',
  'dewas': 'Madhya Pradesh', 'satna': 'Madhya Pradesh', 'ratlam': 'Madhya Pradesh',
  'rewa': 'Madhya Pradesh', 'murwara': 'Madhya Pradesh', 'singrauli': 'Madhya Pradesh',
  'burhanpur': 'Madhya Pradesh', 'khandwa': 'Madhya Pradesh', 'morena': 'Madhya Pradesh',
  'bhind': 'Madhya Pradesh', 'chhindwara': 'Madhya Pradesh', 'mandsaur': 'Madhya Pradesh',
  'shivpuri': 'Madhya Pradesh', 'vidisha': 'Madhya Pradesh', 'damoh': 'Madhya Pradesh',
  'neemuch': 'Madhya Pradesh',

  // Maharashtra
  'mumbai': 'Maharashtra', 'pune': 'Maharashtra', 'nagpur': 'Maharashtra', 'thane': 'Maharashtra',
  'nashik': 'Maharashtra', 'aurangabad': 'Maharashtra', 'solapur': 'Maharashtra',
  'kolhapur': 'Maharashtra', 'amravati': 'Maharashtra', 'nanded': 'Maharashtra',
  'sangli': 'Maharashtra', 'jalgaon': 'Maharashtra', 'akola': 'Maharashtra', 'latur': 'Maharashtra',
  'dhule': 'Maharashtra', 'ahmednagar': 'Maharashtra', 'chandrapur': 'Maharashtra',
  'parbhani': 'Maharashtra', 'ichalkaranji': 'Maharashtra', 'jalna': 'Maharashtra',
  'bhiwandi': 'Maharashtra', 'panvel': 'Maharashtra', 'satara': 'Maharashtra',
  'beed': 'Maharashtra', 'yavatmal': 'Maharashtra', 'osmanabad': 'Maharashtra',
  'navi mumbai': 'Maharashtra', 'wardha': 'Maharashtra', 'gondia': 'Maharashtra',
  'ratnagiri': 'Maharashtra', 'vasai': 'Maharashtra', 'kalyan': 'Maharashtra',
  'ulhasnagar': 'Maharashtra', 'dombivli': 'Maharashtra', 'mira-bhayandar': 'Maharashtra',

  // Manipur
  'imphal': 'Manipur',

  // Meghalaya
  'shillong': 'Meghalaya',

  // Mizoram
  'aizawl': 'Mizoram',

  // Nagaland
  'dimapur': 'Nagaland', 'kohima': 'Nagaland',

  // Odisha
  'bhubaneswar': 'Odisha', 'cuttack': 'Odisha', 'rourkela': 'Odisha', 'berhampur': 'Odisha',
  'sambalpur': 'Odisha', 'puri': 'Odisha', 'balasore': 'Odisha', 'baripada': 'Odisha',
  'bhadrak': 'Odisha', 'jharsuguda': 'Odisha',

  // Punjab
  'ludhiana': 'Punjab', 'amritsar': 'Punjab', 'jalandhar': 'Punjab', 'patiala': 'Punjab',
  'bathinda': 'Punjab', 'mohali': 'Punjab', 'hoshiarpur': 'Punjab', 'batala': 'Punjab',
  'pathankot': 'Punjab', 'moga': 'Punjab', 'abohar': 'Punjab', 'malerkotla': 'Punjab',
  'khanna': 'Punjab', 'phagwara': 'Punjab', 'muktsar': 'Punjab', 'barnala': 'Punjab',
  'rajpura': 'Punjab', 'firozpur': 'Punjab', 'kapurthala': 'Punjab', 'sangrur': 'Punjab',
  'fazilka': 'Punjab', 'faridkot': 'Punjab', 'gobindgarh': 'Punjab', 'mansa': 'Punjab',
  'nawanshahr': 'Punjab', 'sultanpur lodhi': 'Punjab',

  // Rajasthan
  'jaipur': 'Rajasthan', 'jodhpur': 'Rajasthan', 'kota': 'Rajasthan', 'bikaner': 'Rajasthan',
  'ajmer': 'Rajasthan', 'udaipur': 'Rajasthan', 'bhilwara': 'Rajasthan', 'alwar': 'Rajasthan',
  'bharatpur': 'Rajasthan', 'sikar': 'Rajasthan', 'pali': 'Rajasthan', 'sri ganganagar': 'Rajasthan',
  'ganganagar': 'Rajasthan', 'tonk': 'Rajasthan', 'kishangarh': 'Rajasthan',
  'beawar': 'Rajasthan', 'hanumangarh': 'Rajasthan', 'dhaulpur': 'Rajasthan',
  'gangapur city': 'Rajasthan', 'sawai madhopur': 'Rajasthan', 'barmer': 'Rajasthan',
  'churu': 'Rajasthan', 'jhunjhunu': 'Rajasthan', 'nagaur': 'Rajasthan',
  'chittorgarh': 'Rajasthan', 'bundi': 'Rajasthan', 'jaisalmer': 'Rajasthan',
  'dungarpur': 'Rajasthan', 'banswara': 'Rajasthan', 'baran': 'Rajasthan',

  // Sikkim
  'gangtok': 'Sikkim',

  // Tamil Nadu
  'chennai': 'Tamil Nadu', 'coimbatore': 'Tamil Nadu', 'madurai': 'Tamil Nadu',
  'tiruchirappalli': 'Tamil Nadu', 'trichy': 'Tamil Nadu', 'salem': 'Tamil Nadu',
  'tirunelveli': 'Tamil Nadu', 'tirupur': 'Tamil Nadu', 'erode': 'Tamil Nadu',
  'vellore': 'Tamil Nadu', 'thoothukudi': 'Tamil Nadu', 'dindigul': 'Tamil Nadu',
  'thanjavur': 'Tamil Nadu', 'ranipet': 'Tamil Nadu', 'sivakasi': 'Tamil Nadu',
  'karur': 'Tamil Nadu', 'nagercoil': 'Tamil Nadu', 'kanchipuram': 'Tamil Nadu',
  'hosur': 'Tamil Nadu', 'namakkal': 'Tamil Nadu', 'kumbakonam': 'Tamil Nadu',
  'cuddalore': 'Tamil Nadu',

  // Telangana
  'hyderabad': 'Telangana', 'warangal': 'Telangana', 'nizamabad': 'Telangana',
  'karimnagar': 'Telangana', 'ramagundam': 'Telangana', 'khammam': 'Telangana',
  'mahbubnagar': 'Telangana', 'nalgonda': 'Telangana', 'adilabad': 'Telangana',
  'suryapet': 'Telangana', 'siddipet': 'Telangana', 'secunderabad': 'Telangana',

  // Tripura
  'agartala': 'Tripura',

  // Uttar Pradesh
  'lucknow': 'Uttar Pradesh', 'kanpur': 'Uttar Pradesh', 'ghaziabad': 'Uttar Pradesh',
  'agra': 'Uttar Pradesh', 'varanasi': 'Uttar Pradesh', 'meerut': 'Uttar Pradesh',
  'allahabad': 'Uttar Pradesh', 'prayagraj': 'Uttar Pradesh', 'bareilly': 'Uttar Pradesh',
  'aligarh': 'Uttar Pradesh', 'moradabad': 'Uttar Pradesh', 'saharanpur': 'Uttar Pradesh',
  'gorakhpur': 'Uttar Pradesh', 'noida': 'Uttar Pradesh', 'greater noida': 'Uttar Pradesh',
  'firozabad': 'Uttar Pradesh', 'loni': 'Uttar Pradesh', 'jhansi': 'Uttar Pradesh',
  'muzaffarnagar': 'Uttar Pradesh', 'mathura': 'Uttar Pradesh', 'shahjahanpur': 'Uttar Pradesh',
  'rampur': 'Uttar Pradesh', 'ayodhya': 'Uttar Pradesh', 'farrukhabad': 'Uttar Pradesh',
  'maunath bhanjan': 'Uttar Pradesh', 'hapur': 'Uttar Pradesh', 'etawah': 'Uttar Pradesh',
  'mirzapur': 'Uttar Pradesh', 'bulandshahr': 'Uttar Pradesh', 'sambhal': 'Uttar Pradesh',
  'amroha': 'Uttar Pradesh', 'hardoi': 'Uttar Pradesh', 'fatehpur': 'Uttar Pradesh',
  'rae bareli': 'Uttar Pradesh', 'unnao': 'Uttar Pradesh', 'sultanpur': 'Uttar Pradesh',
  'bahraich': 'Uttar Pradesh', 'sitapur': 'Uttar Pradesh', 'lakhimpur': 'Uttar Pradesh',
  'orai': 'Uttar Pradesh', 'banda': 'Uttar Pradesh', 'deoria': 'Uttar Pradesh',
  'azamgarh': 'Uttar Pradesh', 'basti': 'Uttar Pradesh', 'ballia': 'Uttar Pradesh',
  'gonda': 'Uttar Pradesh', 'jaunpur': 'Uttar Pradesh', 'pratapgarh': 'Uttar Pradesh',

  // Uttarakhand
  'dehradun': 'Uttarakhand', 'haridwar': 'Uttarakhand', 'roorkee': 'Uttarakhand',
  'haldwani': 'Uttarakhand', 'rudrapur': 'Uttarakhand', 'kashipur': 'Uttarakhand',
  'rishikesh': 'Uttarakhand', 'nainital': 'Uttarakhand', 'mussoorie': 'Uttarakhand',

  // West Bengal
  'kolkata': 'West Bengal', 'howrah': 'West Bengal', 'durgapur': 'West Bengal',
  'asansol': 'West Bengal', 'siliguri': 'West Bengal', 'bardhaman': 'West Bengal',
  'malda': 'West Bengal', 'baharampur': 'West Bengal', 'habra': 'West Bengal',
  'kharagpur': 'West Bengal', 'shantiniketan': 'West Bengal', 'haldia': 'West Bengal',
  'raiganj': 'West Bengal', 'krishnanagar': 'West Bengal', 'balurghat': 'West Bengal',
  'basirhat': 'West Bengal', 'bankura': 'West Bengal',

  // Jammu & Kashmir
  'srinagar': 'Jammu & Kashmir', 'jammu': 'Jammu & Kashmir', 'anantnag': 'Jammu & Kashmir',
  'sopore': 'Jammu & Kashmir', 'baramulla': 'Jammu & Kashmir', 'kathua': 'Jammu & Kashmir',
  'udhampur': 'Jammu & Kashmir',

  // Ladakh
  'leh': 'Ladakh', 'kargil': 'Ladakh',

  // Chandigarh
  'chandigarh': 'Chandigarh',

  // Puducherry
  'puducherry': 'Puducherry', 'pondicherry': 'Puducherry',

  // Dadra & Nagar Haveli / Daman & Diu
  'silvassa': 'Dadra & Nagar Haveli', 'daman': 'Daman & Diu', 'diu': 'Daman & Diu',
};

/**
 * Lookup state for a given city name. Case-insensitive.
 * @param {string} city
 * @returns {string|null} State name or null
 */
export function getStateForCity(city) {
  if (!city || typeof city !== 'string') return null;
  return CITY_STATE_MAP[city.trim().toLowerCase()] || null;
}
